import { memo } from 'react';

import SpinnerIconSVG from '@/assets/spinner-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

const ISpinnerIcon = ({ className, ...rest }: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={SpinnerIconSVG} className={merge('animate-spin', className)} {...rest} />
);

export const SpinnerIcon = memo(ISpinnerIcon) as typeof ISpinnerIcon;
